import { useRef, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedProductDetails } from '@americanexpress/product-ducks';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import updateLocaleCookie from '../utils/updateLocaleCookie';
import { setTenancyLocale } from '../ducks/tenancyLocale';
import { setIsAAM } from '../ducks/highVolAamReducer';
import { getIsAAM } from '../utils/loadModuleData';
import { moduleName } from '../constants';

export default function useOnTenancyChanges({
  graphqlApiResource,
  locale,
  setClient,
  graphClient,
  dispatch,
}) {
  const selectedProduct = useSelector(getSelectedProductDetails);
  const tenancyLocale = useSelector((state) => state.getIn(['modules', moduleName, 'tenancyLocale', 'locale'], ''));
  const selectedProductRef = useRef(selectedProduct);
  const graphQLApiResourceRef = useRef(graphqlApiResource);

  const updateIsAAM = useCallback(() => {
    selectedProductRef.current = selectedProduct;
    dispatch(setIsAAM(getIsAAM(selectedProduct)));
  }, [dispatch, selectedProduct]);

  const updateGraphQLClient = useCallback(() => {
    graphQLApiResourceRef.current = graphqlApiResource;
    setClient(graphClient(graphqlApiResource));
  }, [setClient, graphClient, graphqlApiResource]);

  const updateTenancyLocale = useCallback(async () => {
    await dispatch(loadLanguagePack(moduleName, { fallbackLocale: 'en-US', locale }));
    dispatch(setTenancyLocale(locale));
    updateLocaleCookie(locale);
  }, [dispatch, locale]);

  useEffect(() => {
    if (selectedProductRef.current !== selectedProduct) updateIsAAM();
  }, [selectedProduct, updateIsAAM]);

  useEffect(() => {
    if (graphQLApiResourceRef.current !== graphqlApiResource) updateGraphQLClient();
  }, [updateGraphQLClient, graphqlApiResource]);

  useEffect(() => {
    if (locale !== tenancyLocale) updateTenancyLocale();
  }, [locale, tenancyLocale, updateTenancyLocale]);
}
